/* This file is autogenerated, see readme.md for instructions */
import KeySvgIcon from '@bloomreach/banana-theme/icons/key.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const KeyIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <KeySvgIcon />
    </Icon>
  );
});

KeyIcon.displayName = 'KeyIcon';

export default KeyIcon;
